export default "__VITE_ASSET__B9Im33vo__"